import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
import { Account } from "../Account/Account";
``;
export class Campaign extends HttpForm {
    data = {
        account: null,
        name: "",
        currency: 'GBP',
        start_date: null,
        end_date: null,
        active: true,
    };
    accounts = false;
    app;
    currencies = false;
    constructor(app) {
        super();
        this.app = app;
    }
    mountForm(slug, edit = false) {
        this.setLoadingState(false);
        let workload = [
            this.loadAllAccounts(),
            this.loadAllCurrencies(),
        ];
        if (edit) {
            workload.push(this.getCampaign(slug));
        }
        Promise.all(workload).then(() => this.setLoadingState(true));
    }
    create() {
        const url = '/api/campaign';
        return axios.post(url, this.data)
            .then(() => this.navigation.toRouteName('admin.campaign'))
            .catch(e => this.setError(e));
    }
    update() {
        const url = '/api/campaign/' + this.data.slug;
        return axios.patch(url, this.data)
            .then(() => this.navigation.toRouteName('admin.campaign'))
            .catch(e => this.setError(e));
    }
    getCampaign(slug) {
        const url = '/api/campaign/' + slug;
        return axios.get(url)
            .then((response) => this.data = response.data.data)
            .catch(e => this.setError(e));
    }
    isAdminUser() {
        if (this.app && this.app.auth) {
            return this.app.auth.role === 'admin';
        }
        return false;
    }
    getAccounts() {
        if (this.accounts === false) {
            throw new Error('No Accounts Loaded');
        }
        return this.accounts;
    }
    getCurrencies() {
        if (this.currencies === false) {
            throw new Error('No Currencies Loaded');
        }
        return this.currencies;
    }
    loadAllAccounts() {
        let self = this;
        if (self.isAdminUser()) {
            return self.account()
                .all()
                .then((response) => {
                self.accounts = response.data.data;
            }).catch(e => self.setError(e));
        }
        else {
            return new Promise(resolve => {
                if (self.app) {
                    self.data.account = self.app.auth.account;
                }
                resolve(true);
            });
        }
    }
    loadAllCurrencies() {
        const url = '/api/currency/all';
        return axios.get(url)
            .then((response) => this.currencies = response.data)
            .catch(e => this.setError(e));
    }
    account() {
        return new Account;
    }
}
